import React from "react";

export default function WhollyOwnedExemptionNotice(props) {
  return(
    (props.disableWhollyOwnedNotice || !props.hasWoDesignation)
      ? null
      : <div className="stat-cards__notice stat-cards__notice--red stat-cards__notice--mb" style={{ lineHeight: 1.5 }}>
        Our records indicate the selected entity has already been granted a wholly owned contract pharmacy exemption. As
        a result of this exemption, the entity is not eligible to designate a single contract pharmacy arrangement and
        any designation you make will not impact access to 340B pricing.
        <a href={props.policy_doc_url}>
          <span style={{ fontWeight: 500, textDecoration: "underline", margin: "0px 5px" }}>
            Download Policy document
          </span>
        </a>
        Please reach out to
        <span style={{ fontWeight: 500 }}> support@340besp.com </span>
        if you have any additional questions or if you do not have access to 340B pricing for your contract pharmacies.
      </div>
  );
};
